import React, { useState, useRef } from 'react';
import Avatar3D from '../components/Avatar3D';

export default function AvatarTest() {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const audioRef = useRef(null);

  const toggleSpeaking = () => {
    setIsSpeaking(!isSpeaking);
    
    if (!isSpeaking && audioRef.current) {
      // Play test audio
      audioRef.current.play();
    } else if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex flex-col items-center justify-center p-8">
      <h1 className="text-4xl font-bold text-white mb-8">
        3D Avatar Test - Viseme Lip Sync
      </h1>
      
      <div className="w-full max-w-4xl aspect-square bg-black/20 rounded-2xl overflow-hidden border border-cyan-500/30 shadow-2xl">
        <Avatar3D 
          isSpeaking={isSpeaking}
          audioElement={audioRef.current}
        />
      </div>

      <button
        onClick={toggleSpeaking}
        className="mt-8 px-8 py-4 rounded-xl text-lg font-semibold bg-gradient-to-r from-cyan-600 to-purple-600 hover:from-cyan-700 hover:to-purple-700 text-white shadow-lg hover:shadow-xl transition-all"
      >
        {isSpeaking ? '⏸️ Dur' : '▶️ Konuşmayı Başlat'}
      </button>

      <div className="mt-4 text-slate-300 text-sm max-w-md text-center">
        <p>Bu test sayfası, viseme tabanlı dudak senkronizasyonunu gösterir.</p>
        <p className="mt-2">Gerçek ses analizi için sesli konuşma modunu kullanın.</p>
      </div>

      {/* Hidden audio for testing */}
      <audio ref={audioRef} loop>
        {/* Using a tone generator - in real use, this would be TTS audio */}
        <source src="data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=" type="audio/wav" />
      </audio>
    </div>
  );
}
